// extracted by mini-css-extract-plugin
export default {"arrow":"DrawerSettings_arrow__ILGPz","dropdown":"DrawerSettings_dropdown__BkFnC"};